import { useMutation, useQueryClient } from "@tanstack/react-query";

import { api } from "@utils/api";
import { showSuccessNotification } from "@utils/showNotification";

import { clinicQKeys } from "@hooks/queries/clinic/queryKeys";
import { useQueryErrorHandling } from "@hooks/useQueryErrorHandling";


export const useCreateClinicFile = () => {
  const queryClient = useQueryClient();
  const handleErrors = useQueryErrorHandling();

  return useMutation({
    mutationFn: (formData: FormData) => {
      return api.post("clinic/files", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
    },
    onSuccess: () => {
      showSuccessNotification({
        title: "success",
        message: "upload-file-success",
      });
      queryClient.invalidateQueries({
        queryKey: clinicQKeys.files(),
      });
    },

    onError: (res: any) => {
      console.error("[From Create Clinic File]", res);
      queryClient.invalidateQueries({
        queryKey: clinicQKeys.files(),
      });

      handleErrors(res, "mutation");
    },
  });
};
